import Page from './Page';
import { AddTaxPage } from './AddTaxPage';
import reducer from './reducer';

export const reducers = { taxManager: reducer };

export { Page, AddTaxPage };
export default { Page, AddTaxPage, reducers };